enum QueryStatus {
  loading = "loading",
  error = "error",
  success = "success"
}

export default QueryStatus;
